export default __webpack_public_path__ + "static/media/JoinSpeed.33f2a4a1.svg";